import {
  MessageSquare,
  Target,
  Heart,
  Home,
  Handshake,
  Sparkles,
  Smartphone,
  Newspaper,
  Palette,
  Music,
  Utensils,
  Hospital,
  Wallet,
  Landmark,
  Users,
  MoonStar,

  // New Icons
  Star,
  Orbit,
  Layers,
  TrendingUp,
} from "lucide-react";


export const CATEGORY_ICON_MAP: Record<string, any> = {
  "message-square": MessageSquare,
  target: Target,
  heart: Heart,
  home: Home,
  handshake: Handshake,
  sparkles: Sparkles,
  smartphone: Smartphone,
  newspaper: Newspaper,
  palette: Palette,
  music: Music,
  utensils: Utensils,
  hospital: Hospital,
  wallet: Wallet,
  landmark: Landmark,
  users: Users,
  "moon-star": MoonStar,

  // 🔮 Astrology Categories
  star: Star,          // ThaiAstro
  orbit: Orbit,        // Uranian
  layers: Layers,      // Tarot
  "trending-up": TrendingUp, // LifeGraph
};
